import { Injectable, ApplicationRef } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class AppStabilityService {
  private firstStable = new ReplaySubject<boolean>(1);
  private firstStable$ = this.firstStable.asObservable();

  constructor(private appRef: ApplicationRef) {
    this.log();
    this.appRef.isStable.pipe(
      first(stable => stable === true)
    ).toPromise().then(() => {
      console.log('Announcing that app is stable for the first time');
      this.firstStable.next(true);
      this.firstStable.complete();
    });
  }

  public whenFirstStable() {
      return this.firstStable$.toPromise();
  }

  private log() {
    this.appRef.isStable.subscribe((stable) => {
      console.log('ApplicationRef isStable: ' + stable);
    });
  }
}
